import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { getLocalJSON } from '../../_helpers/storage.util';
declare var $:any;

@Component({
  selector: 'app-programs',
  templateUrl: './programs.component.html',
  styleUrls: ['./programs.component.scss']
})
export class ProgramsComponent {

  public programListing:any=[];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit = 10;
  public loading:boolean = false;
  public loginDetail:any =[];
  public previousLabel:any='';
  public nextLabel:any='';
  public viewShow:boolean=false;
  public types:any='';
  public Views:boolean=false;
  public OrgList:any=[];

  constructor(public router: Router, public service: GlobalService) {
    this.loginDetail = getLocalJSON('grw_login'); 
    this.getDetail(1);
    this.getOrg();
    }

  ngOnInit(): void {
  }

  getDetail(page:any){
    this.programListing=[];
    this.loading=true;
    var url="/program-list";
    var detail={
      "page": page,
      "status": this.types,
      "is_paginate": true,
      "search": "",
    };
    this.service.PostApis(detail,url).subscribe(((response:any)=>{
      if(response.success ==1) {        
        this.programListing= response.data.record;
        this.totalCount = response.data.total;
        this.loading =false;
      } else {
        this.programListing=[];
        this.loading =false;
      }
      this.viewShow = response.program;

    }), (error) => { this.loading =false; });
  }
  
  redirect(item:any,type:any){
    localStorage.setItem('grw_program',JSON.stringify(item));
    localStorage.setItem('grw_program_id',item._id);
    if(type==1){
      this.router.navigate(['/edit-program']);
    } else {
      this.router.navigate(['/program-video-list']);
    }
  }

  Addredirect(){
    localStorage.setItem('grw_programTrue','1');
    this.router.navigate(['/create-program']);
  }

  redirectCheck(type:any){
    if(this.loginDetail.profile_complete ==true){
      if(this.loginDetail.stripe_account_verify==true){
        if(this.loginDetail.subscription_added==true){
          if(type==1){
            this.router.navigate(['/create-program']); 
          } else {
            localStorage.setItem('grw_programTrue','1');
            this.router.navigate(['/create-program']);
          }
        } else {
          $('#passlink11').trigger('click');
        }
      } else {
        $('#passlink11').trigger('click');
        // Swal.fire({
        //   title: 'Are you sure?',
        //   text: "You won't To add Stripe Account",
        //   icon: 'warning',
        //   showCancelButton: true,
        //   confirmButtonColor: '#3085d6',
        //   cancelButtonColor: '#d33',
        //   confirmButtonText: 'Yes',
        //   cancelButtonText: 'No',
        // }).then((result:any) => {
        //   if (result.isConfirmed) {
        //     this.service.callBankLink();
        //   }
        // });
      }      
    } else {
      $('#passlink11').trigger('click');
    }
  }


  getOrg(){
    this.service.GetApi('/approved-collaborators').subscribe(((response:any)=>{
      if(response.success){
       this.OrgList =response.data;
      }
    }))
  }

  setREvenue(event:any,id:any){
    this.loading=true;
    var detail:any={
      "org_id": event.target.value,
      "program_id": id
    }
    this.service.PostApis( detail,'/program-share').subscribe(((response:any)=>{
      if(response.success){
       this.service.successAlert(response.message);
       this.loading=false;
       this.getDetail(1);
      } else {
        this.service.dangerAlert(response.message);
        this.loading=false;
      }
    }))
  }

  RemoveREvenue(event:any,id:any){
    this.loading=true;
    var detail:any={
      "org_id": event.target.value,
      "program_id": id
    }
    this.service.PostApis( detail,'/album-share').subscribe(((response:any)=>{
      if(response.success){
       this.service.successAlert(response.message);
       this.loading=false;
       this.getDetail(1);
      } else {
        this.service.dangerAlert(response.message);
        this.loading=false;
      }
    }))
  }
}

